<template>
    <v-container
        class="confirmation-container"
        grid-list-lg
    >
        <v-layout column>
            <v-flex>
                <h1
                    v-if="!preSubmit"
                    class="headline"
                >
                    Your return request has been received
                </h1>
                <p>
                    Below are examples of how products should be packaged.
                    <span v-if="!preSubmit">This information and further instructions will be emailed to you shortly.</span>
                </p>
                <return-photos />
            </v-flex>
            <v-flex>
                <v-layout
                    justify-center
                >
                    <v-flex shrink>
                        <v-btn
                            color="primary"
                            @click="onReturn"
                        >
                            Return to invoice
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import ReturnPhotos from '../../components/ReturnPhotos'

export default {
    components: {
        ReturnPhotos
    },
    props: {
        preSubmit: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onReturn () {
            this.$emit('back', true)
        }
    }
}
</script>

<style lang="scss" scoped>
.confirmation-container {
    max-width: 600px;
}
</style>
